const PbxxRecord = require('../pbxx_record')
const _ = require('lodash')

module.exports = class User extends PbxxRecord {
  static get class_name() {
    return 'User'
  }

  can_manage(permissionable_type) {
    return _.some(this.permissions, (permission) => {
      return permission.permissionable_type === permissionable_type
    })
  }

  get has_access_invitations() {
    return this.access_invitations && this.access_invitations.length
  }

  get has_access_requests() {
    return this.access_requests && this.access_requests.length
  }

  get has_actionable_access_requests() {
    return this.actionable_access_requests && this.actionable_access_requests.length
  }

  get has_orphaned_retailers() {
    return this.orphaned_retailers && this.orphaned_retailers.length
  }

  get has_access_invitations_or_requests() {
    return this.has_actionable_access_requests || this.has_access_invitations
  }

  get is_internal_user() {
    return _.some(this.user_roles, (user_role) =>  {
      return user_role === 'admin' || user_role === 'client_services'
    })
  }

  get is_admin() {
    return _.some(this.user_roles, (user_role) =>  {
      return user_role === 'admin'
    })
  }

}
